import React, { useEffect, useState } from 'react';

import { bgNegativeLightest } from '@osmosis/tailwind-ui/styles/background';
import { textNegativeText } from '@osmosis/tailwind-ui/styles/text';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { H2 } from '@osmosis/tailwind-ui/components/Text';
import { H3 } from '@osmosis/tailwind-ui/components/Text';
import { H4 } from '@osmosis/tailwind-ui/components/Text';

type Props = {
  duration: number;
};

const getTimeFromSeconds = (duration: number) => {
  const seconds = duration % 60;
  const minutes = Math.floor(duration / 60) % 60;
  const hours = Math.floor(duration / 60 / 60) % 24;
  const days = Math.floor(duration / 60 / 60 / 24);

  return { days, hours, minutes, seconds };
};

const TimeDisplay = (props: { time: number; label: string }) => {
  const { time, label } = props;

  return (
    <Flex className="flex-col items-center">
      <H2 className={textNegativeText}>{time}</H2>
      <H4 className={`${textNegativeText} uppercase`}>{label}</H4>
    </Flex>
  );
};

const dividerText = ':';

const Divider = () => (
  <H3 className={`${textNegativeText} opacity-50`}>{dividerText}</H3>
);

/**
 * Countdown timer.
 */
const CountdownTimer = (props: Props) => {
  const { duration = 1 * 24 * 60 * 60 } = props;
  const [currentTime, setCurrentTime] = useState(duration);

  const time = getTimeFromSeconds(currentTime);

  useEffect(() => {
    setInterval(() => {
      // Update time
      setCurrentTime((prev) => prev - 1);
    }, 1000);
  }, []);

  return (
    <Flex className="p-3 justify-center">
      <Flex
        className={`${bgNegativeLightest} justify-between items-center p-2 px-3 rounded-[5px] gap-3`}
      >
        <TimeDisplay time={time.days} label="days" />
        <Divider />
        <TimeDisplay time={time.hours} label="hrs" />
        <Divider />
        <TimeDisplay time={time.minutes} label="mins" />
        <Divider />
        <TimeDisplay time={time.seconds} label="secs" />
      </Flex>
    </Flex>
  );
};

export default CountdownTimer;
